module.exports = __webpack_public_path__ + "img/233-complated.0320bd69.png";